import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UpgradeModule } from '@angular/upgrade/static';
import { EmptyComponent, SharedUiModule } from '@mode/shared/ui';
import { LegacyBootstrapService, mark } from '~/legacy-bootstrap.service';
import { loadSignInAngularJsAppShell } from '.';
import { AccountsDomainModule } from '@mode/accounts/domain';

const enableRouterTracing = false;

/**
 * If you want to enable ui-router tracing.
 * Importing trace will add ui-router to the bundle.
 * So it is commented out by default.
 */
// import { trace } from '@uirouter/core';
// trace.enable();

@NgModule({
  imports: [
    CommonModule,
    SharedUiModule,
    UpgradeModule,
    AccountsDomainModule,
    RouterModule.forChild([
      {
        path: '**',
        component: EmptyComponent,
      },
    ]),
  ],
  providers: [
    {
      deps: ['$injector'],
      provide: '$urlService',
      useFactory: ($injector: any) => $injector.get('$urlService'),
    },
    {
      deps: ['$injector'],
      provide: '$transitions',
      useFactory: ($injector: any) => $injector.get('$transitions'),
    },
    LegacyBootstrapService,
  ],
})
export class SignInShellModule {
  constructor(
    private upgrade: UpgradeModule,
    private legacy: LegacyBootstrapService,
    private injector: Injector
  ) {
    this.legacy.bootstrap(loadAngularJsApp, this.upgrade, this.injector);
  }
}

async function loadAngularJsApp() {
  mark('mode.sign-in.js', 'mode.webapp_ui.resource.js.mode.sign-in');
  loadSignInAngularJsAppShell();
}
